<template>
  <u-avatar
    :size="size"
    :src="container.avatarImage"
    :ui="{background: 'bg-shell', icon: {base: 'text-charcoal/60 scale-125'}, rounded}"
    img-class="object-cover"
  />
</template>

<script setup>
  const props = defineProps({
    container: Object,
    size: {
      type: String,
      default: 'md'
    }
  });

  const rounded = computed(() => {
    switch (props.size) {
      case '2xs':
      case 'xs':
      case 'sm':
      case 'md':
        return 'rounded';
      default:
        return 'rounded-lg';
    }
  });
</script>
